// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"feed_wrapper__2UQNR","feed":"feed_feed__3GHqx","orders":"feed_orders__8CqEB","scrollable":"feed_scrollable__TAsW0"};